import { StateSchema } from 'app/config/storeConfig/types';
import { SizeCodeFormDrawerSchema } from '../types';

export const getSizeCodeFormState = (state: StateSchema): SizeCodeFormDrawerSchema => state.sizeCodeFormDrawer;
